import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const ServerDatabaseIcon = createIcon({
  displayName: 'ServerDatabaseIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path d="M24,0H0V24H24Z" fill="none" />
      <path d="M3,8V5A2,2,0,0,1,5,3H8" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path
        d="M21,17v2a2,2,0,0,1-2,2H16"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M21,5.39286C21,6.28064,18.98529,7,16.5,7S12,6.28064,12,5.39286"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M15,13.90161A11.87367,11.87367,0,0,0,16.5,14c2.48529,0,4.5-.71936,4.5-1.60714V4.60714C21,3.71936,18.98529,3,16.5,3S12,3.71936,12,4.60714V8"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M15,10.40161A11.87367,11.87367,0,0,0,16.5,10.5c2.48529,0,4.5-.71936,4.5-1.60714"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="7.49995"
        y1="18.5"
        x2="7.50005"
        y2="21"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="9.5"
        y1="20.99998"
        x2="5.5"
        y2="20.9999"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <rect
        x="3"
        y="12"
        width="9"
        height="6.5"
        rx="1.15"
        strokeWidth="1.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </>
  ),
})

const ServerDatabase: FC<IconProps> = (props) => {
  return <CustomIcon as={ServerDatabaseIcon} {...props} />
}

export default memo(ServerDatabase)
